import type { SupportThreadStatus } from '@loopandroll/api-types';
import type { Tone } from '../../components/tone.ts';
import type { MessageKey } from '../../i18n/index.ts';

/**
 * Le ton de chaque statut d'un fil (§ 10.1 du contrat) : ce qui avance en
 * bleu, ce qui attend une décision en jaune, ce qui est livré en vert, ce qui
 * est refusé en rouge. Le libellé est écrit à côté : la couleur ne parle
 * jamais seule.
 */
export const SUPPORT_STATUS_TONE: Readonly<Record<SupportThreadStatus, Tone>> = {
  received: 'neutral',
  in_study: 'info',
  quoted: 'warning',
  in_progress: 'info',
  delivered: 'success',
  rejected: 'danger',
  open: 'info',
  closed: 'neutral',
};

/** Le libellé de chaque statut : une table, pour que chaque clé existe au catalogue. */
export const SUPPORT_STATUS_LABEL: Readonly<Record<SupportThreadStatus, MessageKey>> = {
  received: 'support.status.received',
  in_study: 'support.status.in_study',
  quoted: 'support.status.quoted',
  in_progress: 'support.status.in_progress',
  delivered: 'support.status.delivered',
  rejected: 'support.status.rejected',
  open: 'support.status.open',
  closed: 'support.status.closed',
};
